// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsForfeitAllowedPropertyDto
 */
export interface IIsForfeitAllowedPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsForfeitAllowedPropertyDto
     */
    is_forfeit_allowed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsForfeitAllowedPropertyDto
     */
    is_forfeit_allowed_state?: IIsForfeitAllowedPropertyDtoIsForfeitAllowedStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsForfeitAllowedPropertyDtoIsForfeitAllowedStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsForfeitAllowedPropertyDto interface.
 */
export function instanceOfIIsForfeitAllowedPropertyDto(value: object): value is IIsForfeitAllowedPropertyDto {
    return true;
}

export function IIsForfeitAllowedPropertyDtoFromJSON(json: any): IIsForfeitAllowedPropertyDto {
    return IIsForfeitAllowedPropertyDtoFromJSONTyped(json, false);
}

export function IIsForfeitAllowedPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsForfeitAllowedPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_forfeit_allowed': json['is_forfeit_allowed'] == null ? undefined : json['is_forfeit_allowed'],
        'is_forfeit_allowed_state': json['is_forfeit_allowed_state'] == null ? undefined : json['is_forfeit_allowed_state'],
    };
}

export function IIsForfeitAllowedPropertyDtoToJSON(json: any): IIsForfeitAllowedPropertyDto {
    return IIsForfeitAllowedPropertyDtoToJSONTyped(json, false);
}

export function IIsForfeitAllowedPropertyDtoToJSONTyped(value?: IIsForfeitAllowedPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_forfeit_allowed': value['is_forfeit_allowed'],
        'is_forfeit_allowed_state': value['is_forfeit_allowed_state'],
    };
}

